import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { selectGroupGuid, useAppSelector } from '../../slices/commonSelectors';
import { LocationResourcesWithBooms, Location } from '../../types/locations';

export const keys = {
  locations: 'locations',
};

export const useLocations = (resourceType: LocationResourcesWithBooms) => {
  const groupGuid = useAppSelector(selectGroupGuid);

  return useQuery({
    queryKey: [keys.locations, groupGuid, resourceType],
    queryFn: async () => {
      const response = await axios.get<Location[]>(
        `${config.apiGateway.ics_locations}/${groupGuid}?resourceType=${resourceType}`
      );
      return response.data;
    },
    enabled: Boolean(groupGuid && resourceType),
  });
};
